// extracted by mini-css-extract-plugin
export default {"base":"base-p2Ug3"};